import terms from './terms'
import privacy from './privacy'
import cookies from './cookies'
import refund from './refund'

const pages = {
  terms,
  privacy,
  cookies,
  refund,
}

export function getLegalPage(page, locale) {
  const pack = pages[page]
  if (!pack) return null
  const lang = locale === 'id' ? 'id' : 'en'
  return pack[lang] || pack.en
}

export const legalPages = Object.keys(pages)
